import React, { createContext, useContext } from 'react';

import { UseWavelinkResult, useWavelinkConnection } from '@/hooks/useWavelink';

const WavelinkContext = createContext<UseWavelinkResult>({
    status: 'disconnected',
    isQueryCovered: () => false,
});

export function useWavelink(): UseWavelinkResult {
    return useContext(WavelinkContext);
}

export function WavelinkProvider({ children }: { children: React.ReactNode }) {
    const value = useWavelinkConnection();

    return <WavelinkContext.Provider value={value}>{children}</WavelinkContext.Provider>;
}
